/*
  Shared "subject" search for Hampshire Prints: ships, regiments, squadrons, aircraft, vehicles,
  wars, places, class and collection pages, from assets/ship-finder-index.json (built by
  ship-finder/update.js). Used by the homepage ship-finder (sections/ship-finder.liquid), the
  header search on every page (snippets/header-subjects.liquid) and the "Did you mean" on the
  search results page (sections/main-search.liquid).

  window.HPSubjectsConfig = { index: <index url>, routes: { collections, products, blogs, search, root } }
  must be set before this file loads.

  find(q) first matches what was typed. Only if that finds nothing does it try to understand a
  slip: words run together ("hmsfearless", "tenbyvictorious"), a gap in a pennant ("f 127"), O for
  zero ("ro9"), a typo ("kemperfelt", "lymx") or a word that matches nothing ("sea vixen mk2").
  Corrections are only ever made towards the names of ships, units and subjects in the index,
  never towards any word in any title (that turned "partridge" into "cartridges").
*/
window.HPSubjects = (function () {
  var cfg = window.HPSubjectsConfig || {};
  var R = cfg.routes || {};
  var PREFIX = /^(hms|rfa|hmy|hmnzs|hmcs|hmas)\s+/;
  var PREFIX_WORDS = { hms: 1, rfa: 1, hmy: 1, hmnzs: 1, hmcs: 1, hmas: 1 };
  // Words that mean nothing on their own: a correction must keep at least one other word.
  var FILLER = { the: 1, of: 1, and: 1, a: 1, class: 1, ship: 1, ships: 1, photo: 1, photos: 1, print: 1, prints: 1, picture: 1, pictures: 1, royal: 1, navy: 1 };
  // Branch number in the index -> colour name (navy is the default).
  var BRANCH_COLOUR = ['', 'rfa', 'marines', 'green', 'lightblue', 'sepia'];
  // vocab: every searchable word; names: only words from the names themselves, the only words a
  // typo may be corrected towards (correcting towards nicknames gave "president" -> Gift cards).
  var subjects = null, vocab = null, names = null, loading = null;

  function searchUrl(q) { return R.search + '?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last'; }

  // Where a suggestion goes: "c:" collection, "p:" product, "l:" any shop page, "v" a ship's own view
  // of the search, "u:"/"e:" a unit or event view ("Name|alias!excluded"), otherwise the normal search.
  function urlFor(row) {
    var link = row[4];
    if (link.indexOf('c:') === 0) return R.collections + '/' + link.slice(2);
    if (link.indexOf('p:') === 0) return R.products + '/' + link.slice(2);
    if (link.indexOf('l:') === 0) return (R.root || '') + link.slice(2);
    if (link === 'v') return R.search + '?q=' + encodeURIComponent('title:"' + row[0] + '"') + '&type=product,article&view=ship';
    if (link.indexOf('u:') === 0 || link.indexOf('e:') === 0) {
      var parts = link.slice(2).split('!');
      var titles = function (names, join) { return names.split('|').map(function (n) { return join + 'title:"' + n + '"'; }); };
      return R.search + '?q=' + encodeURIComponent(titles(parts[0], '').join(' OR ') + (parts[1] ? ' ' + titles(parts[1], 'NOT ').join(' ') : '')) +
        '&type=product,article&view=' + (link.charAt(0) === 'e' ? 'event' : 'ship');
    }
    return searchUrl(row[0]);
  }

  // Lower case, hyphens dropped ("F-35B" = "f35b", "D-Day" = "dday"), brackets and commas as spaces.
  function wordsOf(text) {
    return String(text).toLowerCase().replace(/['’]/g, '').replace(/-/g, '').replace(/[(),./]/g, ' ').split(/\s+/).filter(Boolean);
  }

  function load() {
    if (loading) return loading;
    loading = fetch(cfg.index).then(function (r) { return r.json(); }).then(function (data) {
      vocab = {}; names = {};
      subjects = data.subjects.map(function (row) {
        // Other names in row[8] ("3 PARA", "Sappers") and a ship's class ("Type 23 Frigate") are
        // searchable too; the label alone is shown.
        var words = wordsOf(row[0] + ' ' + (row[8] || '').replace(/\|/g, ' ') + ' ' + (/collection$/i.test(row[2] || '') ? '' : (row[2] || '')));
        words.forEach(function (w) { vocab[w] = 1; });
        if (row[4].indexOf('l:') !== 0) wordsOf(row[0]).forEach(function (w) { names[w] = 1; });
        return {
          label: row[0], branch: row[1], desc: row[2], count: row[3], url: urlFor(row),
          // Wars and places ("e:" links) are listed after ships and units of the same name, so
          // "plymouth" offers HMS Plymouth before the city.
          place: row[4].indexOf('e:') === 0 ? 1 : 0,
          link: row[4],
          yearNames: row[10] || '',
          // Prints per place or war, from row[11] "Portsmouth:3,Falklands:2", for "red arrows portsmouth".
          places: (row[11] || '').split(',').reduce(function (o, p) { var i = p.lastIndexOf(':'); if (i > 0) o[p.slice(0, i)] = Number(p.slice(i + 1)); return o; }, {}),
          // Prints per year, from row[9] "2009:8,2010:3", for "cumberland 2010".
          years: (row[9] || '').split(',').reduce(function (o, p) { var a = p.split(':'); if (a[1]) o[a[0]] = Number(a[1]); return o; }, {}),
          article: row[5] ? { strap: row[5], url: R.blogs + data.blogs[row[6]] + '/' + row[7] } : null,
          colour: /Red Arrows/.test(row[0]) ? 'red' : (BRANCH_COLOUR[row[1]] || 'navy'),
          words: words,
          // "Prints from 1945" sorts as "1945", so typing a year puts that year first.
          bare: row[0].toLowerCase().replace(PREFIX, '').replace(/^prints from (the )?/, '')
        };
      });
      vocab = Object.keys(vocab); names = Object.keys(names);
      return subjects;
    }).catch(function () { loading = null; return null; });
    return loading;
  }

  function queryWords(q) {
    // "h m s hermes", "h ms" -> "hms"; "hmsfearless" -> "hms fearless"
    q = String(q).replace(/\bh\.?\s?m\.?\s?s\b\.?/gi, 'hms');
    var all = wordsOf(q).reduce(function (out, w) {
      var m = w.match(/^(hms|rfa|hmy|hmas|hmnzs|hmcs)([a-z]{3,})$/);
      return out.concat(m ? [m[1], m[2]] : [w]);
    }, []);
    // Little words don't narrow anything down: "gift for my dad" searches "gift dad".
    var kept = all.filter(function (w) { return !LITTLE[w]; }).map(function (w) { return SAME[w] || w; });
    return kept.length ? kept : all;
  }
  // Common shorthand typed for words in the names: "617 sqdn" = "617 squadron".
  var SAME = { sqdn: 'squadron', sqd: 'squadron', sqdrn: 'squadron', sqdn1: 'squadron', regt: 'regiment', rgt: 'regiment', bn: 'battalion' };
  var LITTLE = { for: 1, a: 1, an: 1, the: 1, my: 1, of: 1, and: 1, with: 1, in: 1, on: 1, to: 1, from: 1, me: 1, i: 1, at: 1, by: 1,
    // Everything here is a photo print, so these narrow nothing: "photos of hms ark royal",
    // "picture of a chinook", "history of hms cumberland".
    photo: 1, photos: 1, photograph: 1, photographs: 1, picture: 1, pictures: 1, pic: 1, pics: 1, print: 1, prints: 1,
    image: 1, images: 1, history: 1, story: 1 };

  // Every typed word must start one of the subject's words ("ark" finds Ark Royal, not Clark);
  // a typed plural also counts without its s ("tanks", "paras").
  function startsWord(sw, w) {
    return sw.indexOf(w) === 0 || (w.length > 3 && w.charAt(w.length - 1) === 's' && sw.indexOf(w.slice(0, -1)) === 0);
  }
  // How many typed words are whole words of the subject, singular or plural ("frigate" = "Frigates").
  var BRANCH_WORDS = { royal: 1, navy: 1, raf: 1, british: 1, army: 1, fleet: 1, auxiliary: 1, air: 1, force: 1, all: 1, class: 1, and: 1 };
  // A word typed exactly scores 2, its singular or plural 1: "greys" is the Royal Scots Dragoon
  // Guards (nickname "Greys") before RFA Grey Rover, "tigers" the PWRR before the Tiger class.
  function whole(s, words) {
    // A collection page counts the plural of a main word in its name as exact: "frigate" opens Royal
    // Navy Frigates first, "minesweeper" the Minesweepers and Minehunters page. Branch words don't
    // count, so "royals" doesn't favour every "Royal Navy" page.
    var page = /collection$/i.test(s.desc || '');
    var nouns = page ? wordsOf(s.label).filter(function (x) { return !BRANCH_WORDS[x]; }) : [];
    return words.reduce(function (n, w) {
      if (s.words.indexOf(w) > -1) return n + 2;
      var plural = s.words.indexOf(w + 's') > -1 || (w.charAt(w.length - 1) === 's' && s.words.indexOf(w.slice(0, -1)) > -1);
      var nounPlural = nouns.indexOf(w + 's') > -1 || (w.charAt(w.length - 1) === 's' && nouns.indexOf(w.slice(0, -1)) > -1);
      return n + (nounPlural ? 2 : plural ? 1 : 0);
    }, 0);
  }
  function exact(words) {
    if (!subjects || !words.length) return [];
    var bareQ = words.join(' ').replace(PREFIX, '');
    if (!bareQ) return [];
    return subjects.filter(function (s) {
      return words.every(function (w) { return s.words.some(function (sw) { return startsWord(sw, w); }); });
    }).sort(function (a, b) {
      var as = a.bare.replace(/-/g, '').indexOf(bareQ) === 0 ? 0 : 1, bs = b.bare.replace(/-/g, '').indexOf(bareQ) === 0 ? 0 : 1;
      // Whole words typed beat the start of a longer word: "a3" is the A3 print size before RFA ship A389.
      return whole(b, words) - whole(a, words) || as - bs || a.place - b.place || b.count - a.count || a.label.localeCompare(b.label);
    });
  }
  function match(q) { return exact(queryWords(q)); }

  // ---- the forgiving fallback -------------------------------------------------------------
  // Typing distance with swapped letters counting as one slip ("castel" / "castle").
  function distance(a, b) {
    var d = [], i, j;
    for (i = 0; i <= a.length; i++) { d[i] = [i]; }
    for (j = 0; j <= b.length; j++) { d[0][j] = j; }
    for (i = 1; i <= a.length; i++) {
      for (j = 1; j <= b.length; j++) {
        var cost = a[i - 1] === b[j - 1] ? 0 : 1;
        d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cost);
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
      }
    }
    return d[a.length][b.length];
  }
  // A word counts as recognised if it is a whole searchable word, or the start of one and at least
  // 4 letters long (so a stray "las" doesn't stand in for Lashkar Gah).
  function known(w) {
    return vocab.indexOf(w) > -1 || /^\d+$/.test(w) && vocab.indexOf(w) > -1 ||
      (w.length >= 4 && vocab.some(function (v) { return startsWord(v, w); }));
  }
  // Slips allowed: none under 4 letters, 1 up to 8, 2 for longer words; the first letter must match.
  function allowed(w) { return w.length < 4 || /\d/.test(w) ? 0 : w.length <= 8 ? 1 : 2; }
  // Only whole words are corrected (guessing from part-typed words turned "volage" into Voyager).
  // A 4-letter word may only have one letter changed ("lymx" -> "lynx").
  function closest(w) {
    var max = allowed(w), best = null, bestD = max + 1;
    if (!max) return null;
    names.forEach(function (v) {
      if (v.charAt(0) !== w.charAt(0) || Math.abs(v.length - w.length) > max) return;
      if (w.length === 4 && v.length !== 4) return;
      var d = distance(w, v);
      if (d < bestD || (d === bestD && best && v.length < best.length)) { bestD = d; best = v; }
    });
    return bestD <= max ? best : null;
  }
  // "tenbyvictorious" -> "tenby victorious"; "fragatabroadsword" -> "broadsword".
  function unglue(w) {
    for (var i = 3; i <= w.length - 3; i++) {
      if (names.indexOf(w.slice(0, i)) > -1 && names.indexOf(w.slice(i)) > -1) return [w.slice(0, i), w.slice(i)];
    }
    // One long name making up most of the word ("fragatabroadsword", "battleshipsfiring").
    var tail = null;
    names.forEach(function (v) {
      if (v.length >= 7 && v.length >= w.length * 0.55 && w.length > v.length && (w.slice(-v.length) === v || w.indexOf(v) === 0) && (!tail || v.length > tail.length)) tail = v;
    });
    return tail ? [tail] : null;
  }
  // Words that can be left out of a search without changing what it's for.
  var NOISE = /^(\d.*|.*\d|mk\d*|pictures?|photos?|photographs?|images?|prints?|posters?|framed|colou?r|diesel|electric|old|uk)$/;
  // Returns { words, pair } for a corrected search, or null when there is no safe correction.
  function loose(q) {
    if (!vocab) return null;
    var words = queryWords(q), out = [], changed = false, corrected = false, dropped = false, pair = null, real = false;
    var isName = function (x) { return names.indexOf(x) > -1 || (x.length >= 4 && names.some(function (v) { return v.indexOf(x) === 0; })); };
    // Words that match nothing may only be left out from the END, and only if they are noise
    // ("sea vixen mk2", "charybdis 1940", "oberon diesel electric"). Anything else means there is no
    // safe guess: "girdle ness", "king charles" and "defence discount" get no suggestion.
    function keep(list) { if (dropped) return false; out = out.concat(list); return true; }
    for (var i = 0; i < words.length; i++) {
      var w = words[i], next = words[i + 1], after = words[i + 2];
      // "f 127" -> "f127", "f 35 b" -> "f35b": a pennant or type split by spaces.
      if (/^[a-z]{1,2}$/.test(w) && next && /^\d{1,4}$/.test(next)) {
        if (after && /^[a-z]$/.test(after) && vocab.indexOf(w + next + after) > -1) { if (!keep([w + next + after])) return null; i += 2; changed = true; real = true; continue; }
        if (vocab.indexOf(w + next) > -1) { if (!keep([w + next])) return null; i++; changed = true; real = true; continue; }
      }
      // "ro9" -> "r09": letter O typed for a zero in a pennant.
      if (/^[a-z]{1,2}[o0-9]*o[o0-9]*$/.test(w) && /\d/.test(w)) {
        var z = w.slice(0, w.search(/[o0-9]/)) + w.slice(w.search(/[o0-9]/)).replace(/o/g, '0');
        if (vocab.indexOf(z) > -1) { if (!keep([z])) return null; changed = true; real = true; continue; }
      }
      if (PREFIX_WORDS[w] || known(w)) { if (!keep([w])) return null; continue; }
      var c = closest(w);
      if (c) { if (!keep([c])) return null; changed = true; corrected = true; real = true; continue; }
      var parts = unglue(w);
      if (parts) {
        if (!keep(parts)) return null;
        if (parts.length === 2 && parts[0].length >= 5 && parts[1].length >= 3) pair = parts;
        changed = true; real = true; continue;
      }
      // A number can't be dropped after a name was corrected: "wiston 1205" is HMS Wiston M1205,
      // not HMS Wilton.
      if (!NOISE.test(w) || (corrected && /\d/.test(w))) return null;
      changed = true;
      dropped = true;
    }
    var meaningful = out.filter(function (x) { return !PREFIX_WORDS[x] && !FILLER[x]; });
    if (!changed || !meaningful.some(function (x) { return x.length >= 3 || /\d/.test(x); })) return null;
    // After leaving a word out, what's left must be part of a name, not just a description.
    if (dropped && !meaningful.every(isName)) return null;
    // quiet: only noise was left out ("tornado gr4" -> Tornado), so it's a direct hit, not a guess.
    return { words: out, pair: pair, quiet: !real };
  }

  // What the boxes and the search page call: { items, closest } where closest means the list is
  // a best guess rather than an exact match for what was typed.
  // With a year added ("cumberland 2010", "paras 2016", "617 squadron 2010") the subjects that have
  // prints dated that year are offered as "HMS Cumberland F85 in 2010", opening just those prints.
  // If none has prints from that year, the subjects themselves are offered as the closest match.
  // A year on its own ("1982") is an ordinary subject in the list ("Prints from 1982").
  var YEAR = /^(18|19|20)\d\d$/;
  function find(q) {
    var words = queryWords(q);
    var years = words.filter(function (w) { return YEAR.test(w); });
    var rest = words.filter(function (w) { return !YEAR.test(w); });
    if (years.length !== 1 || !rest.length || !subjects) {
      var plain = findWords(q);
      if (plain.items.length && !plain.closest) return plain;
      var combos = placeCombos(words);
      return combos.length ? { items: combos, closest: false } : plain;
    }
    var y = years[0], base = findWords(rest.join(' ')), dated = [];
    base.items.slice(0, 12).forEach(function (s) {
      var n = s.years[y], url = n && narrowUrl(s, [y], '');
      if (url) dated.push(narrowed(s, s.label + ' in ' + y, n, url));
    });
    if (dated.length) return { items: dated, closest: base.closest };
    return { items: base.items, closest: base.items.length > 0 };
  }
  function narrowed(s, label, count, url) {
    return { label: label, desc: s.desc, count: count, url: url, colour: s.colour, article: s.article, bare: s.bare, words: s.words, place: s.place };
  }

  // Something plus a place or war, either way round: "red arrows portsmouth", "hermes falklands",
  // "falklands hermes". Offered only where prints have both, with the true count.
  function placeCombos(words) {
    var found = [], seen = {};
    for (var k = 1; k < words.length; k++) {
      [[words.slice(0, k), words.slice(k)], [words.slice(k), words.slice(0, k)]].forEach(function (pair) {
        var where = exact(pair[1]).filter(function (p) { return p.link.indexOf('e:') === 0 && !/^Prints from/.test(p.label); })[0];
        if (!where) return;
        exact(pair[0]).slice(0, 12).forEach(function (s) {
          var n = s.places[where.label], url = n && narrowUrl(s, null, where.link);
          if (url && !seen[url]) { seen[url] = 1; found.push(narrowed(s, s.label + ': ' + where.label, n, url)); }
        });
      });
    }
    return found;
  }

  // The subject's own search, narrowed to a year (["2010"]) or to a place's names ("e:Falklands|...").
  function narrowUrl(s, years, placeLink) {
    var link = s.link;
    if (link.indexOf('p:') === 0) return s.url;
    // A unit with its own collection page searches its title words instead ("Red Arrows").
    if (link.indexOf('c:') === 0 && s.yearNames) link = 'u:' + s.yearNames;
    var titles = function (names, join) { return names.split('|').map(function (n) { return join + 'title:"' + n + '"'; }); };
    var parts, base, nots = '';
    if (link === 'v') base = 'title:"' + s.label + '"';
    else if (link.indexOf('u:') === 0 || link.indexOf('e:') === 0) {
      parts = link.slice(2).split('!');
      base = '(' + titles(parts[0], '').join(' OR ') + ')';
      if (parts[1]) nots = ' ' + titles(parts[1], 'NOT ').join(' ');
    } else return null;
    var narrow = years ? 'title:"' + years[0] + '"' : '(' + titles(placeLink.slice(2).split('!')[0], '').join(' OR ') + ')';
    return R.search + '?q=' + encodeURIComponent(base + ' AND ' + narrow + nots) +
      '&type=product,article&view=' + (link.charAt(0) === 'e' ? 'event' : 'ship');
  }

  function findWords(q) {
    var items = match(q);
    if (items.length || !subjects) return { items: items, closest: false };
    var fixed = loose(q);
    if (!fixed) return { items: [], closest: false };
    items = exact(fixed.words);
    if (!items.length && fixed.pair) {
      // Two ship names run together ("brilliantbristol", "tenbyvictorious"): offer each.
      var seen = {}, prefixes = fixed.words.filter(function (y) { return PREFIX_WORDS[y]; });
      fixed.pair.forEach(function (x) {
        exact(prefixes.concat([x])).slice(0, 4).forEach(function (s) { if (!seen[s.url]) { seen[s.url] = 1; items.push(s); } });
      });
    }
    return { items: items, closest: items.length > 0 && !fixed.quiet };
  }

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  // Bold the part of each word that was typed.
  function highlight(label, q) {
    var words = queryWords(q);
    return label.split(' ').map(function (lw) {
      var low = lw.toLowerCase().replace(/-/g, '');
      var w = words.filter(function (x) { return low.indexOf(x) === 0; }).sort(function (a, b) { return b.length - a.length; })[0];
      if (!w) return esc(lw);
      // Keep the hyphens of the label when bolding ("F-35B").
      var n = 0, k = 0;
      while (k < lw.length && n < w.length) { if (lw.charAt(k) !== '-') n++; k++; }
      return '<mark>' + esc(lw.slice(0, k)) + '</mark>' + esc(lw.slice(k));
    }).join(' ');
  }

  function countText(s) { return s.count ? s.count + (s.count === 1 ? ' print' : ' prints') : ''; }

  return { load: load, match: match, find: find, highlight: highlight, esc: esc, searchUrl: searchUrl, countText: countText, queryWords: queryWords };
})();
